import * as Apis from '../../utils/apisRequest'


export default {
    //获取金币明细
    //https://apisdev.aigupiao.com/UserCenter/user_gold_detail/?appversion=11.8.0&u_id=44324&before=0
    async user_gold_detail(opt){
        return await Apis.get({
            url:'/UserCenter/user_gold_detail/',
            params: {
                ...opt
            }
        })
    },
    //获取用户协议
    //https://apisdev.aigupiao.com/v1/user/agreements?u_id=44324
    async agreement(opt){
        return await Apis.get({
            url:'/v1/user/agreements',
            params: {
                ...opt
            }
        })
    },
    //获取购买会员评论
    //https://apis.aigupiao.com/v2/userEvaluationOfTeachers/?l_id=120
    async userEvaluationOfTeachers(opt){
        return await Apis.get({
            url:'/v2/userEvaluationOfTeachers',
            params: {
                ...opt
            }
        })
    },
    //获取购买会员相关
    //https://apis.aigupiao.com/LiveBuyVip/index/?appversion=11.7.0&u_id=44324&l_id=120
    async LiveBuyVip(opt){
        return await Apis.get({
            url:'/LiveBuyVip/index/',
            params: {
                ...opt
            }
        })
    },
}
